import React from "react";
import EngineeringIcon from "./EngineeringIcons";

const WhatWeDo: React.FC = () => {
  const capabilities = [
    {
      title: "INNOVATION HUB",
      description:
        "Leading-edge research and development facility driving breakthrough engineering solutions across all disciplines. We pioneer sustainable technologies that transform industries.",
      icon: "🔬",
      impact: "R&D Excellence"
    },
    {
      title: "AGRICULTURAL REVOLUTION",
      description:
        "Advanced farm machinery and food processing lines that modernize agriculture. From automated harvesting to complete food production systems, we're feeding the future.",
      icon: "🚜",
      impact: "Food Security"
    },
    {
      title: "SUSTAINABLE ENERGY",
      description:
        "Revolutionary energy solutions including pyrolysis systems, electric vehicles, and renewable energy technologies. Powering Ekumfiman's sustainable future.",
      icon: "⚡",
      impact: "Green Energy"
    },
    {
      title: "MARINE ENGINEERING",
      description:
        "Expert boat and yacht construction combining traditional craftsmanship with modern engineering. Building vessels that connect communities and drive maritime commerce.",
      icon: "🚢",
      impact: "Maritime Development"
    },
    {
      title: "WOOD PROCESSING",
      description:
        "Advanced woodworking and timber processing solutions. From precision cutting to automated manufacturing systems for sustainable forestry products.",
      icon: "🪵",
      impact: "Resource Efficiency"
    },
    {
      title: "INFRASTRUCTURE DEVELOPMENT",
      description:
        "Comprehensive plumbing and infrastructure engineering. Building the essential systems that support industrial growth and community development.",
      icon: "🔧",
      impact: "Infrastructure"
    },
    {
      title: "SUSTAINABLE CONSTRUCTION",
      description:
        "Innovative building solutions including interlocking bricks and eco-friendly materials. Creating durable, cost-effective, and environmentally conscious structures.",
      icon: "🏗️",
      impact: "Green Building"
    },
    {
      title: "SKILLS DEVELOPMENT",
      description:
        "Comprehensive TVET training center empowering the next generation of engineers and skilled professionals. Building human capital for sustainable development.",
      icon: "🎓",
      impact: "Human Capital"
    },
    {
      title: "DIGITAL TRANSFORMATION",
      description:
        "Cutting-edge software engineering and machine learning solutions. Developing intelligent systems that automate and optimize industrial processes.",
      icon: "💻",
      impact: "Digital Innovation"
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">How We Industrialize Ekumfiman</h2>
          <p className="text-gray-600 max-w-4xl mx-auto text-lg">
            Through our nine engineering keystones, we're creating a comprehensive ecosystem that drives sustainable development, 
            empowers communities, and builds the infrastructure needed for population-driven growth.
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 engineering-card"
            >
              {/* Icon and Impact */}
                             <div className="flex items-center justify-between mb-4">
                 <div className="text-4xl animate-pulley-bounce">{capability.icon}</div>
                <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm font-semibold">
                  {capability.impact}
                </span>
              </div>

              {/* Content */}
              <div>
                <h3 className="text-xl font-bold mb-3 text-gray-800">{capability.title}</h3>
                <p className="text-gray-600 leading-relaxed">{capability.description}</p>
              </div>

              {/* Learn More Link */}
              <div className="mt-4">
                               <button className="text-orange-500 font-semibold hover:text-orange-600 transition-colors flex items-center gap-2 group">
                 <EngineeringIcon type="gear" size="sm" className="group-hover:animate-gear-spin" />
                 Explore Capabilities
                 <svg
                   className="w-4 h-4"
                   fill="none"
                   stroke="currentColor"
                   viewBox="0 0 24 24"
                 >
                   <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth={2}
                     d="M9 5l7 7-7 7"
                   />
                 </svg>
               </button>
              </div>
            </div>
          ))}
        </div>

        {/* Mission Statement */}
        <div className="mt-16 bg-gradient-to-r from-orange-500 to-orange-600 text-white p-8 rounded-lg">
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
            <p className="text-lg mb-4">
              <strong>To industrialize Ekumfiman through engineering excellence</strong>
            </p>
            <p className="text-lg mb-6">
              We are committed to creating a unique self-sustainable environment that spearheads 
              population-driven development through innovative engineering solutions.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <span className="bg-white/20 px-4 py-2 rounded-full">Sustainable Development</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Community Empowerment</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Innovation Leadership</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Economic Growth</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
